/**
 * Auto-generated by yarn cross-type:gen-typescript. Do not edit by hand.
 *
 * @source dashboard/lib/shared/braze/remote_lookup/providers/cohort_remote_lookup_provider.rb
 * @owner @Appboy/messaging-experience
 */

import { z } from "zod";

/** @see [ruby definition](../../../../../../../../lib/shared/braze/remote_lookup/providers/cohort_remote_lookup_provider.rb) */
export const filtersTypeSchema = z.strictObject({
  partner_token: z
    .enum(["a", "ab", "af", "ap", "b", "c", "cf", "db", "h", "ht", "k", "m", "s", "sa", "sh", "t", "tr"])
    .nullable()
    .optional(),
});

/** @see [ruby definition](../../../../../../../../lib/shared/braze/remote_lookup/providers/cohort_remote_lookup_provider.rb) */
export const filtersTypeOutputSchema = z.object({
  partner_token: z
    .enum(["a", "ab", "af", "ap", "b", "c", "cf", "db", "h", "ht", "k", "m", "s", "sa", "sh", "t", "tr"])
    .nullable()
    .optional(),
});
